import { queryOptions, useQuery } from '@tanstack/react-query';
import { APIHeader } from '..';
import { privateClient } from '../axiosClients/axiosClients';

export function getFilesQueryOptions(params, options) {
  return queryOptions({
    queryKey: ['files', params],
    queryFn: () => console.log('Fetching files with params:', params),
    ...options,
  });
}

export function getCostImpactFilesQueryOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['cost-impact', params],
    queryFn: () => getCostImpactFiles(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
export async function getCostImpactFiles(params) {
  try {
    if (!params.pecrId || !params.siteId) {
      return;
    }
    const response = await privateClient.post('/FetchFilesForCostImpact', {
      MainFolder: 'PECROverview',
      SubFolder: params.pecrId,
      siteId: params.siteId,
      costImpact: 'CostImpact',
    });
    return response.data;
  } catch (error) {
    console.log('Error fetching cost impact files:', error);
  }
}

export function useFetchFilesFromDepartment(payload, uiURL) {
  return useQuery({
    queryKey: ['files-from-department', payload],
    queryFn: async () => {
      try {
        // Fetch files from a specific department
        const response = await fetch(`${uiURL}api/FetchFilesFromDepartment`, {
          method: 'POST',
          headers: APIHeader(),
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.log('Error fetching files from department:', error);
      }
    },
    retry: 1,
    //5 min stale time for cache
    staleTime: 1000 * 60 * 5,
  });
}

export async function uploadCostImpactFile({ file, pecrId, siteId }) {
  const uploadData = new FormData();
  uploadData.append('file', file);
  uploadData.append('MainFolder', 'PECROverview');
  uploadData.append('SubFolder', pecrId);
  uploadData.append('siteId', siteId);
  uploadData.append('costImpact', 'CostImpact');

  const response = await privateClient.post(
    '/UploadDocForCostImpact',
    uploadData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
}

export async function deleteCostImpactFile({ fileName, pecrId, siteId }) {
  const response = await privateClient.post('/DeleteCostImpactFile', {
    MainFolder: 'PECROverview',
    SubFolder: pecrId,
    fileName: fileName,
    siteId: siteId,
  });
  return response.data;
}
